// https://stuk.github.io/jszip/
import JSZip from "jszip";
// https://github.com/eligrey/FileSaver.js/
import { saveAs } from "file-saver";

export const downloadSheetsZip = async ({
  fillinSheets,
  finishedSheets,
  paletteTiles,
  sheetData,
  fileName = "downloadStuff",
}) => {
  const zip = new JSZip();

  // Generate a directory within the Zip file structure
  const folder1 = zip.folder("cards-for-printing");
  const folder2 = zip.folder("completed-sheets-for-ref");
  const folder3 = zip.folder("palette");

  let count = 0;
  for (let canvas of fillinSheets) {
    const canvasBlobData = await canvasToBlob(canvas);
    const finishedCanvasBlobData = await canvasToBlob(finishedSheets[count]);

    // Add a file to the folder, in this case an image with data URI as contents
    folder1.file(`${fileName}_card_${count + 1}.png`, canvasBlobData, {
      base64: true,
    });
    folder2.file(
      `COMPLETED-${fileName}_card_${count + 1}.png`,
      finishedCanvasBlobData,
      {
        base64: true,
      }
    );
    count++;
  }

  // Add an top-level, arbitrary text file with contents
  const { blockCounts, totalSheets, sheetsHigh, sheetsWide } = sheetData.global;
  let informationText = `Total Sheets: ${totalSheets} (${sheetsWide} x ${sheetsHigh})\n`;

  informationText += `Stickers needed: \n`;

  const labels = Object.keys(blockCounts);
  for (let lab of labels) {
    informationText += `${lab}: ${blockCounts[lab]} \n`;
  }

  let paletteNum = 0;
  for (let paletteObj of paletteTiles) {
    // informationText += `${paletteNum}) ${paletteObj.label}: ${
    //   blockCounts[paletteNum - 1]
    // }\n`;
    const canvasBlobData = await canvasToBlob(paletteObj.canvas);
    // Add a file to the directory, in this case an image with data URI as contents
    if (paletteNum > 0) {
      folder3.file(`${fileName}_sticker_${paletteNum}.png`, canvasBlobData, {
        base64: true,
      });
    }

    paletteNum++;
  }

  zip.file("information.txt", informationText);

  const nowStr = getDateString();

  // Generate the zip file asynchronously
  zip.generateAsync({ type: "blob" }).then(function (content) {
    // Force down of the Zip file
    saveAs(content, `${fileName}_${nowStr}.zip`);
  });
};

const canvasToBlob = (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob(
      (blobData) => {
        resolve(blobData);
      },
      "image/png",
      1
    );
  });
};

function getDateString() {
  const date = new Date();
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  const hour = `${date.getHours()}`.padStart(2, "0");
  const mins = `${date.getMinutes()}`.padStart(2, "0");
  const secs = `${date.getSeconds()}`.padStart(2, "0");
  return `${year}-${month}-${day}__${hour}h-${mins}m-${secs}s`;
}
